import React from 'react';
import {LeaderboardItemType} from '../../types';
import {Image} from 'antd-mobile';
import {toPriceStr} from '@components/utils';

const defaultUser =
  require('@/common-pages/leaderboard/assets/user-default-2.svg').default;

interface LeaderboardItemProps {
  item: LeaderboardItemType;
  rank: number;
}

const LeaderboardItem: React.FC<LeaderboardItemProps> = ({item, rank}) => {
  return (
    <div className="h-[3.375rem] flex items-center w-full rounded bg-white px-4 py-1.5 gap-1.5">
      <div className="font-medium w-8">{rank}</div>
      <Image
        src={item.avatar || defaultUser}
        className="rounded-full size-11"></Image>
      <div>
        <div>{item.username}</div>
        <div className="mt-0.5">
          Point:{' '}
          <span className="text-c2 font-medium">
            {toPriceStr(item.point, {
              showCurrency: false,
              suffixUnit: 'K',
              overPrice: 10000,
            })}
          </span>
        </div>
      </div>
      <div className="ml-auto">
        <div className="text-right">Bonus</div>
        <div className="text-c2 font-medium">
          {toPriceStr(item.bonus, {
            showCurrency: true,
            suffixUnit: 'K',
            overPrice: 10000,
          })}
        </div>
      </div>
    </div>
  );
};
export default LeaderboardItem;
